/**
 * Setuts Gui up after load ist finished
 **/
/* global $ */
/* global mdc */
class Gui {
    constructor() {
        this.dialogs = {};
        this.dropDowns = {};
        this.menus = [];
        this.sliders = {};
        this.mainSnackBar = undefined;
        this.pendingFinished = [];
        this.textFields = [];
    }

    registerSlider(name, slider){
        this.sliders[name] = slider
    }
    
    initRipples() {
        $(".effects--ripple").each(function(id, button){
            try {
                mdc.ripple.MDCRipple.attachTo(button);
            }
            catch (e) {}
        })
        
    }
    
    addTextField(id, textField){
        this.textFields[id] = textField;
    }
    
    setTextFieldContent(id, content){
        this.textFields[id].root.innerHTML = content;
    }
    
    openDropDown(id){
         this.dropDowns[id].open = true;
    }
    
    initDropDowns(){
        var _self = this;
        $(".mdc-select").each(function(id, dropdown){
            try {
                 var dropDownId = $(dropdown).attr("id");
                 var mdcDropDown = new mdc.select.MDCSelect(dropdown);
                _self.dropDowns[dropDownId] = mdcDropDown;
                
            }
            catch (e) {
                console.log(e)
            }
        })
    }
    
    initMenus(){
        var _self = this;
        $(".mdc-menu").each(function(id, menuElement){
            try {
                 var anchorKey = $(menuElement).attr("ac-map-click-within-parent");
                 var isInitialized = $(menuElement).attr("ac-is-initialized");
                 if(!isInitialized && anchorKey != undefined){
                     var anchor = $(menuElement).parent().find("[ac-send-click-within-parent='"+anchorKey+"']");
                     var menu = new mdc.menu.MDCMenu(menuElement);
                     var ind = _self.menus.length;
                     _self.menus.push(menu);
                     $(anchor).on("click", function(){
                        gui.menus[ind].setAnchorElement(anchor[0]);
                        gui.menus[ind].hoistMenuToBody();
                        setTimeout(function(){
                            gui.menus[ind].open = true;
                        },50)
                        
                     });
                 }
                 $(menuElement).attr("ac-is-initialized", true);
            }
            catch (e) {
                console.log(e);
            }
        });
    }

    initTextFields() {
        try {
            document.querySelectorAll('.mdc-text-field').forEach(function(el) {
                new mdc.textField.MDCTextField(el);
            });
        }
        catch (e) {}
    }

    initDrawer() {
        mdc.topAppBar.MDCTopAppBar.attachTo(document.querySelector('.mdc-top-app-bar'));
        const drawer = mdc.drawer.MDCDrawer.attachTo(document.querySelector('.mdc-drawer'));
        const topAppBar = mdc.topAppBar.MDCTopAppBar.attachTo(document.querySelector('.mdc-top-app-bar'));
        topAppBar.setScrollTarget(document.querySelector('.mdc-drawer'));
        topAppBar.listen('MDCTopAppBar:nav', () => {
            drawer.open = !drawer.open;
        })
    }

    initDialogs() {
        var dialogs = $(".atlas-dialog");
        var _self = this;
        dialogs.each(function(id, dialog) {
            var dialogId = $(dialog).attr("id");
            var mdcDialog = new mdc.dialog.MDCDialog(dialog);
            _self.dialogs[dialogId] = mdcDialog;
        })
    }

    openDialog(dialogId, dialogInitVars) {
        if(dialogInitVars == undefined){
            this.dialogs[dialogId].open()
        }else{
            this.dialogs[dialogId].open()
        }
        
    }
    
    setSliderValue(name, value){
        gui.sliders[name].foundation_.setValue_(value)
        gui.sliders[name].emit("MDCSlider:change");
    }

    initFileInputs() {
        var inputs = document.querySelectorAll('.c__fileinput');
        Array.prototype.forEach.call(inputs, function(input) {
            var label = input.nextElementSibling,
                labelVal = label.innerHTML;

            input.addEventListener('change', function(e) {
                var fileName = '';
                if (this.files && this.files.length > 1)
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                else
                    fileName = e.target.value.split('\\').pop();

                if (fileName)
                    label.querySelector('span').innerHTML = fileName;
                else
                    label.innerHTML = labelVal;
            });
        });
    } 
    
    showSnackBar(msg){
        this.mainSnackBar.labelText = msg.message
        if(msg.actionText != undefined){
            this.mainSnackBar.actionButtonText = msg.actionText;
            this.mainSnackBar.listen("MDCSnackbar:closing", function(data){
                if(data.reason == "action"){
                    msg.actionHandler();
                }
            })
        }
        this.mainSnackBar.open();
    }
    
    initSnackBars(){
        this.mainSnackBar = new mdc.snackbar.MDCSnackbar(document.querySelector('.mdc-snackbar'));
    }
    
    onFinished(callback){
        this.pendingFinished.push(callback)
    }

    init() {
        this.initRipples();
        this.initTextFields()
        try{
            this.initDrawer()
        }catch(e){}
        
        this.initDialogs()
        this.initFileInputs()
        this.initDropDowns()
        this.initSnackBars()
        this.initMenus()
        window.mdc.autoInit();
        
        this.pendingFinished.forEach(function(callback){
            callback()
        })
    }

}

var gui = new Gui();

$(document).ready(function() {
    gui.init();

})
